import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Table,
  Space,
  Popconfirm,
  Modal
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FileSearchOutlined, SearchOutlined } from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import SystemInput from './SystemInput'

const System = () => {
  //mobx
  const { SystemStore } = useStore();

  //获得table数据
  useEffect(() => {
    SystemStore.getDataList();
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(SystemStore, { page: page, pagesize: pageSize })
    })
    SystemStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(SystemStore, { isActive: false });
    });
  };

  //单个删除按钮
  const deleteConfirm = async (item) => {
    let id = toJS(item).id;
    toJS(SystemStore.dataList).filter((item) => item.id !== id);
    await SystemStore.getDeleteButtom(id);
  };

  //新增账户
  const getAddButton = (addTitle, data) => {
    if (addTitle === '编辑' || addTitle === '查看') {
      runInAction(() => {
        set(SystemStore, { valueData: toJS(data) });
      })
    }
    runInAction(() => {
      set(SystemStore, { title: addTitle, isActive: true });
    });
  };

  // 取消按钮
  const [form] = Form.useForm();


  //表单提交
  const onFinish = async (values) => {
    if (values.name) {
      runInAction(() => {
        set(SystemStore, { xtmc: values.name, page: 1 })
      })
      await SystemStore.getDataList();
    } else if (values.name === undefined || values.name === '') {
      runInAction(() => {
        set(SystemStore, { xtmc: '', page: 1 })
      })
      await SystemStore.getDataList();
    }

  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const start = async () => {

    setLoading(true);
    await SystemStore.getDeleteButtom(toJS(SystemStore.moreId));

    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const onSelectChange = (newSelectedRowKeys) => {

    runInAction(() => {
      set(SystemStore, { moreId: newSelectedRowKeys.toString() })
    })
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "系统编号",
      dataIndex: "xtbh",
    },
    {
      title: "系统名称",
      dataIndex: "xtmc",
    },
    {
      title: "系统IP",
      dataIndex: "xtip",
    },
    {
      title: "系统状态",
      dataIndex: "xtzt",
      render: (text) => text === 1 ? "启用" : "禁用"
    },
    {
      title: "联系人",
      dataIndex: "xtlxr"
    },
    {
      title: "联系电话",
      dataIndex: "xtlxdh",
    },
    {
      title: "接入时间",
      dataIndex: "createtime",
    },
    {
      title: "操作",
      render: (item) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => getAddButton("查看", item)}
          >查看</Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => getAddButton("编辑", item)}
          >编辑</Button>
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              deleteConfirm(item);
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
          </Popconfirm>

        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="searchBox">
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item label="关键词" name="name">
            <Input placeholder="请输入系统名称" style={{ width: "260px" }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ background: '#40ad63' }}>
              查询
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="TableInput">
        <div className="buttonBox">
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              start()
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} style={{ background: '#6a8d9f', marginRight: '10px' }} disabled={!hasSelected} >
              批量删除
            </Button>}
          </Popconfirm>

          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="addTitle"
            onClick={() => getAddButton("添加", '')}
          >
            添加系统
          </Button>
        </div>
        <div className="total">共有数据:{SystemStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={SystemStore.dataList}
          rowSelection={rowSelection}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: SystemStore.pagesize,
            current: SystemStore.page,
            total: SystemStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={SystemStore.title}
        key={new Date()}
        width="600px"
        open={SystemStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <SystemInput title={SystemStore.title} />
      </Modal>
    </>
  );
};

export default observer(System);
